// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"8bb6bc19","35":"b8225435","40":"0438e328","78":"bc4925c4","444":"22838b3d","453":"a2d80f35","550":"369c1fec","590":"faafcc0a","720":"9a2c3358","776":"a274f4df","784":"3e72d0c6","857":"ae06baf1"}[chunkId] + ".chunk.js";
};